import { BreadcrumbSwitcherPopover } from '@/view/shared/Breadcrumbs/BreadcrumbSwitcherPopover';
import type { BreadcrumbItem } from '@/viewmodel/shared/breadcrumbs';
import { ChevronRight } from 'lucide-react';
import type { ReactElement } from 'react';
import { Link } from 'react-router-dom';

export interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export function BreadcrumbsComponent({ items }: BreadcrumbsProps): ReactElement {
  return (
    <nav aria-label="Breadcrumbs" className="min-w-0">
      <ol className="flex items-center gap-0.5 min-w-0">
        {items.map((item, index) => {
          const isCurrent = index === items.length - 1;
          const hasHref = Boolean(item.href);

          return (
            <li
              key={`${item.href ?? ''}|${item.label}`}
              className="flex items-center gap-0.5 min-w-0 shrink"
            >
              {isCurrent || !hasHref ? (
                <span
                  className="text-xs sm:text-sm text-muted font-medium px-0.5 truncate max-w-30 sm:max-w-50"
                  aria-current={isCurrent ? 'page' : undefined}
                  aria-disabled={isCurrent || !hasHref || undefined}
                  title={item.label}
                >
                  {item.label}
                </span>
              ) : (
                <Link
                  className="text-xs sm:text-sm text-muted font-medium px-0.5 hover:underline truncate max-w-30 sm:max-w-50"
                  to={item.href as string}
                  title={item.label}
                >
                  {item.label}
                </Link>
              )}
              {item.switcher && <BreadcrumbSwitcherPopover config={item.switcher} />}
              {!isCurrent && <ChevronRight className="size-3 shrink-0 text-muted rtl:rotate-180" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
